export default [
  "/blog/digital-transformation/announcing-solution-partners/",
  "/blog/digital-transformation/anvils-advanced-editor/",
  "/blog/digital-transformation/why-we-built-document-editor/",
  "/blog/engineering/build-vs-buy-e-signatures/",
  "/blog/engineering/build-vs-buy-pdf-service/",
  "/blog/engineering/introducing-interactive-fields/",
  "/blog/tutorial/create-a-pdf-over-api/",
  "/blog/tutorial/custom-stylesheets-in-anvil/",
  "/blog/tutorial/etch-e-sign-webinar/",
  "/blog/tutorial/monthly-financial-statement-pdf-efta/",
  "/blog/tutorial/setting-up-postman-for-anvil/",
  "/blog/tutorial/workflows-webinar/",
  "/forms/taxes/form-8300/",
  "/forms/taxes/fw-8-ben/",
  "/forms/taxes/irs-w4/",
  "/forms/taxes/irs-w9/",
  "/help/document-templates/fill-dynamic-templates-over-api/",
  "/help/document-templates/fill-pdfs-over-api/",
  "/help/document-templates/set-up-a-pdf-template/",
  "/help/document-templates/set-up-dynamic-templates/",
  "/help/document-templates/text-tags/",
  "/help/etch-e-sign/add-and-remove-pdf-fields/",
  "/help/etch-e-sign/change-the-signature-type-on-a-signature-field/",
  "/help/etch-e-sign/convert-a-word-doc-to-a-pdf/",
  "/help/etch-e-sign/download-output-files/",
  "/help/etch-e-sign/fill-and-sign-pdfs-with-etch/",
  "/help/etch-e-sign/reorder-pdfs-in-a-packet/",
  "/help/etch-e-sign/set-default-signer-options/",
  "/help/etch-e-sign/signer-options-and-types/",
  "/help/etch-e-sign/text-tags/",
  "/help/etch-e-sign/view-timeline/",
  "/help/etch-e-sign/void-a-signature/",
  "/help/org-settings/manage-etch-email-notification-settings/",
  "/help/org-settings/manage-workflow-email-notifications/",
  "/help/pdf-editor/add-and-remove-pdf-fields/",
  "/help/pdf-editor/add-logic-to-a-pdf/",
  "/help/pdf-editor/build-workflows-with-dynamic-templates/",
  "/help/pdf-editor/dynamically-fill-pdf-fields/",
  "/help/pdf-editor/fill-pdf-fields-in-workflows/",
  "/help/pdf-editor/navigate-through-the-workflow-editor/",
  "/help/signer-editor/add-signer-logic/",
  "/help/signer-editor/fill-and-sign-pdfs-with-etch/",
  "/help/signer-editor/navigate-through-the-workflow-editor/",
  "/help/webform-editor/custom-colors/",
  "/help/webform-editor/limit-items-in-a-list-field/",
  "/help/webform-editor/navigate-through-the-workflow-editor/",
  "/help/webform-editor/pdf-upload-field-autodetect-faq/",
  "/help/webform-editor/prefill-webform-fields/",
  "/help/webform-editor/set-field-character-limits/",
  "/help/webform-editor/turn-any-document-into-a-workflow/",
  "/help/workflows/add-a-default-value-to-a-webform-field/",
  "/help/workflows/add-a-file-upload-field-to-a-webform/",
  "/help/workflows/add-a-page-break-to-a-webform/",
  "/help/workflows/add-a-pdf-to-a-workflow/",
  "/help/workflows/add-a-signer-to-a-workflow/",
  "/help/workflows/add-a-webform-to-a-workflow/",
  "/help/workflows/add-access-control-to-a-webform/",
  "/help/workflows/add-an-address-field-to-a-pdf/",
  "/help/workflows/add-an-embedded-video-to-a-webform/",
  "/help/workflows/add-and-format-explanation-text-in-webforms/",
  "/help/workflows/add-and-remove-pdf-fields/",
  "/help/workflows/add-extra-fields-to-webforms/",
  "/help/workflows/add-help-tips-to-webforms/",
  "/help/workflows/add-images-and-logos-to-webforms/",
  "/help/workflows/add-logic-to-a-pdf-field/",
  "/help/workflows/add-logic-to-a-webform-field/",
  "/help/workflows/add-logic-to-a-webform-list/",
  "/help/workflows/add-logic-to-a-webform-page/",
  "/help/workflows/add-multiple-signers-to-a-workflow/",
  "/help/workflows/advanced-json-editor/",
  "/help/workflows/automate-pdfs-with-workflows/",
  "/help/workflows/change-field-type-on-pdf/",
  "/help/workflows/change-the-format-of-a-date-selector-in-a-webform/",
  "/help/workflows/change-the-signature-type-on-a-signature-field/",
  "/help/workflows/change-the-type-of-a-webform-field/",
  "/help/workflows/complete-multiple-pdfs-at-once/",
  "/help/workflows/create-a-radio-group-on-a-pdf/",
  "/help/workflows/create-a-webform-list/",
  "/help/workflows/create-boxes-per-letter/",
  "/help/workflows/default-to-todays-date/",
  "/help/workflows/disconnect-a-signer-from-an-individual-field/",
  "/help/workflows/dynamically-fill-pdf-fields/",
  "/help/workflows/edit-a-signer/",
  "/help/workflows/fill-a-pdf-using-zapier/",
  "/help/workflows/format-the-output-of-a-pdf/",
  "/help/workflows/limit-items-in-a-list-field/",
  "/help/workflows/link-to-anvil-submission-with-zapier/",
  "/help/workflows/list-arrays-complex-info/",
  "/help/workflows/make-a-field-optional/",
  "/help/workflows/map-a-list-to-a-pdf/",
  "/help/workflows/map-a-webform-dropdown-field-to-a-pdf/",
  "/help/workflows/mark-fields-to-be-signed/",
  "/help/workflows/prefill-webform-fields/",
  "/help/workflows/progressive-signing/",
  "/help/workflows/remove-or-merge-webform-fields/",
  "/help/workflows/remove-signers-from-a-workflow/",
  "/help/workflows/reorder-fields-on-a-webform/",
  "/help/workflows/reorder-pdfs-in-a-packet/",
  "/help/workflows/reorder-signers-in-a-workflow/",
  "/help/workflows/save-and-complete-a-webform-later/",
  "/help/workflows/select-and-edit-multiple-pdf-fields-at-once/",
  "/help/workflows/set-field-character-limits/",
  "/help/workflows/set-up-anvil-workflow-trigger-with-zapier/",
  "/help/workflows/signer-options-and-types/",
  "/help/workflows/start-and-prefill-anvil-workflow-from-zapier/",
  "/help/workflows/test-a-webform-from-the-workflow-editor/",
  "/help/workflows/text-tags/",
  "/help/workflows/translate-webforms-automatically/",
  "/help/workflows/turn-any-document-into-a-workflow/",
  "/help/workflows/update-a-pdf/",
  "/help/workflows/white-label-settings/"
]
